import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { JaneDoePostCardStackContentViewModel } from './jane-doe-post-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-jane-doe-post-card-stack-content',
  templateUrl: './jane-doe-post-card-stack-content.component.html',
  styleUrls: ['./jane-doe-post-card-stack-content.component.scss'],
  providers: [JaneDoePostCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JaneDoePostCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: JaneDoePostCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
